import src from "IMAGE";
export default { src, width: 171, height: 171, blurWidth: 0, blurHeight: 0};
